<template>
  <v-row v-if="audit" align="center">
    <v-col cols="12" sm="5">
      <slot name="old-values" :values="JSON.parse(audit.old_values)">
        <json-details :json="JSON.parse(audit.old_values)" dense />
      </slot>
    </v-col>
    <v-col cols="12" sm="2" align="center">
      <v-icon :class="{ 'rotate-plus-90': $vuetify.breakpoint.xs }">
        $freshvueaudits-arrow-right
      </v-icon>
    </v-col>
    <v-col cols="12" sm="5">
      <slot name="new-values" :values="JSON.parse(audit.new_values)">
        <json-details :json="JSON.parse(audit.new_values)" dense />
      </slot>
    </v-col>
  </v-row>
</template>

<script>
import { JsonDetails } from '@freshsolutions/fresh-vue'

export default {
  name: 'AuditChanges',

  components: {
    JsonDetails
  },

  props: {
    audit: {
      type: Object,
      required: false,
      default: null
    }
  }
}
</script>
